import { Service } from '@roc/feature-app-core';

const url = {
  MOVE_TO_EXTERNAL_CAPITAL: '/platform-api/v1/los-loans/loans/move-to-external-capital-provider',
};

export class MoveToExternalCapitalService extends Service {
  moveToExternalCapital(platformCapitalLoanId: string) {
    return this.post(
      `${url.MOVE_TO_EXTERNAL_CAPITAL}?platformCapitalLoanId=${platformCapitalLoanId}`,
      {}
    );
  }
}
